function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: a , size: r = 24  } = _param, c = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = s(), l = a !== null && a !== void 0 ? a : t ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, c), {
        children: /* @__PURE__ */ e("path", {
            fill: l,
            d: "M19.788 21.826H9.298c-.712 0-1.155-.445-1.155-1.16v-4.115a5.791 5.791 0 01-1.748-.987l-3.249 3.374a.56.56 0 11-.807-.779L5.6 14.774a5.803 5.803 0 012.543-9.167V3.322c0-.706.443-1.146 1.152-1.149h6.51a.55.55 0 01.394.166L21.662 7.8a.55.55 0 01.165.395v12.496c0 .686-.446 1.128-1.129 1.131-.302.003-.605.003-.91.003zm-9.715-4.947c-.274 0-.545-.019-.81-.056v3.883h11.44V8.759h-2.167c-.956 0-1.78-.317-2.376-.916-.596-.6-.916-1.42-.916-2.375V3.297h-5.98v2.036a5.8 5.8 0 014.91 9.846 5.759 5.759 0 01-4.1 1.7zm6.292-12.79v1.379c0 .652.201 1.198.585 1.585.384.387.933.588 1.583.588h1.378L16.365 4.09zm-10.97 6.992a4.678 4.678 0 004.684 4.678 4.682 4.682 0 003.305-7.992 4.646 4.646 0 00-3.31-1.37 4.678 4.678 0 00-4.678 4.684z"
        })
    }));
}, m = i;
export { m as default };
